// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__NQvXd","dragIcon":"SortableItem_dragIcon__2puBo","disabled":"SortableItem_disabled__HPaYV"};